const mapOptions=(arr, id, label)=>{
    // console.log(arr)
    return arr?.map(item=>{
        return {id:item[id],label:item[label]||"No-Name"}
    })
}

export default mapOptions